module.exports = __webpack_public_path__ + "static/media/logo-external-retina.22199e93.png";